export default "__VITE_ASSET___F8E3M9P__"